import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["onChange"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(t), !0)).call(_context4, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React from "react";
import { Chip, makeStyles } from "componentLibrary";
import GoogleMapsAddressSelect from "./GoogleMapsAddressSelect";
import useGlobalMessage from "components/GlobalMessageSnackbar/useGlobalMessage";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    chipContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px",
      marginTop: "8px"
    }
  };
});
var CitySelect = function CitySelect(_ref) {
  var _props$tagCities, _props$locationCities;
  var onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var _React$useState = React.useState((_props$tagCities = props.tagCities) !== null && _props$tagCities !== void 0 ? _props$tagCities : []),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedTagCities = _React$useState2[0],
    setSelectedTagCities = _React$useState2[1];
  var _React$useState3 = React.useState((_props$locationCities = props.locationCities) !== null && _props$locationCities !== void 0 ? _props$locationCities : []),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    locationCities = _React$useState4[0],
    setLocationCities = _React$useState4[1];
  var _useGlobalMessage = useGlobalMessage(),
    showGlobalMessage = _useGlobalMessage.showGlobalMessage;
  var findType = function findType(_ref2) {
    var addressComponents = _ref2.addressComponents,
      type = _ref2.type;
    return _findInstanceProperty(addressComponents).call(addressComponents, function (c) {
      var _context;
      return _includesInstanceProperty(_context = c.types).call(_context, type);
    }) || {};
  };
  var handleCityTagsChanged = function handleCityTagsChanged(newTagCities) {
    setSelectedTagCities(newTagCities);
  };
  var _onChange = function _onChange(_ref3) {
    var _value$addressCompone, _value$terms, _findType$long_name, _findType;
    var _ref3$target = _ref3.target,
      name = _ref3$target.name,
      value = _ref3$target.value;
    var addressComponents = (_value$addressCompone = value === null || value === void 0 ? void 0 : value.addressComponents) !== null && _value$addressCompone !== void 0 ? _value$addressCompone : null;
    var terms = (_value$terms = value === null || value === void 0 ? void 0 : value.terms) !== null && _value$terms !== void 0 ? _value$terms : [];
    if (!addressComponents && terms.length === 0) {
      return;
    }
    var city = (_findType$long_name = (_findType = findType({
      addressComponents: addressComponents,
      type: "locality"
    })) === null || _findType === void 0 ? void 0 : _findType.long_name) !== null && _findType$long_name !== void 0 ? _findType$long_name : null;
    if (!city) {
      var _findType$long_name2, _findType2;
      city = (_findType$long_name2 = (_findType2 = findType({
        addressComponents: addressComponents,
        type: "political"
      })) === null || _findType2 === void 0 ? void 0 : _findType2.long_name) !== null && _findType$long_name2 !== void 0 ? _findType$long_name2 : null;
    }
    if (!city) {
      return showGlobalMessage === null || showGlobalMessage === void 0 ? void 0 : showGlobalMessage("City not provided", "error");
    }
    if (!_includesInstanceProperty(selectedTagCities).call(selectedTagCities, city)) {
      var _context2, _context3;
      handleCityTagsChanged(_concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(selectedTagCities), [city]));
      return onChange({
        target: {
          name: name,
          value: _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(selectedTagCities), [city])
        }
      });
    }
  };
  props = _objectSpread(_objectSpread({}, props), {}, {
    types: ["locality"] // Only show cities
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GoogleMapsAddressSelect, _objectSpread(_objectSpread({}, props), {}, {
      onChange: _onChange,
      useStateReducer: true
    })), /*#__PURE__*/_jsxs("div", {
      className: classes.chipContainer,
      children: [selectedTagCities && selectedTagCities.length > 0 && _mapInstanceProperty(selectedTagCities).call(selectedTagCities, function (city) {
        return /*#__PURE__*/_jsx(Chip, {
          label: city,
          onDelete: function onDelete() {
            var updatedCities = _filterInstanceProperty(selectedTagCities).call(selectedTagCities, function (c) {
              return c !== city;
            });
            handleCityTagsChanged(updatedCities);
            onChange({
              target: {
                name: props.name,
                value: updatedCities
              }
            });
          }
        }, city);
      }), locationCities && locationCities.length > 0 && _mapInstanceProperty(locationCities).call(locationCities, function (city) {
        return /*#__PURE__*/_jsx(Chip, {
          label: city,
          disabled: true
        }, city);
      })]
    })]
  });
};
export default CitySelect;